<template>
  <div class="container col-5">
      <h1>404 not found</h1>
      <h2>it seems you're in the wrong page</h2>
  </div>
</template>

